import Raven from 'raven-js';
import attachments from '../attachments/attachments';
import documentsCollection from '../commons/rest/onlineDocumentsRest';
import { DocumentEntity } from '../../../shared/src/entity';

/**
 * ====================================
 * The actions
 * ====================================
 */
const LOAD_DOCUMENT_START = 'LOAD_DOCUMENT_START';
const LOAD_DOCUMENT_METADATA_SUCCESS = 'LOAD_DOCUMENT_METADATA_SUCCESS';
const LOAD_DOCUMENT_METADATA_FAILURE = 'LOAD_DOCUMENT_METADATA_FAILURE';
const LOAD_DOCUMENT_ATTACHMENT_SUCCESS = 'LOAD_DOCUMENT_ATTACHMENT_SUCCESS';
const LOAD_DOCUMENT_ATTACHMENT_FAILURE = 'LOAD_DOCUMENT_ATTACHMENT_FAILURE';
const RESET_DOCUMENT = 'RESET_DOCUMENT';


/**
 * ====================================
 * The actions creators
 * ====================================
 */

const getAttachment = (document, attachmentId) => (attachmentId == null ?
  document :
  document.attachments.find(att => att.id === attachmentId) || document);

const loadSynchronizedDocumentAttachment = () => (dispatch, getState) =>
  attachments.loadAttachment(getState().document.metadata.id)
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      dispatch({ type: LOAD_DOCUMENT_ATTACHMENT_SUCCESS, payload: url });
    })
    .catch((err) => {
      dispatch({ type: LOAD_DOCUMENT_ATTACHMENT_FAILURE, payload: err });
      console.error('Error while loading synchronized document', err);
      Raven.captureException(err);
    });

const loadUrlDocumentAttachment = (document, attachmentId) => ({
  type: LOAD_DOCUMENT_ATTACHMENT_SUCCESS,
  payload: document.getAttachmentUrl(attachmentId),
});

export const loadDocument = (documentId, attachmentId) => (dispatch, getState) => {
  dispatch({ type: LOAD_DOCUMENT_START, payload: { documentId, attachmentId } });

  const { roadmap, documents, search } = getState();

  // Roadmap
  if (!documentId) {
    dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: roadmap.data });
    return dispatch(loadSynchronizedDocumentAttachment());
  }

  // Synchronized document
  const offlineDocument = documents.data.find(doc => doc.id === documentId);
  if (offlineDocument) {
    dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: getAttachment(offlineDocument, attachmentId) });
    return dispatch(loadSynchronizedDocumentAttachment());
  }

  // Unsynchronized document with metadata in the search results
  const searchDocument = search && search.historyDocuments
    && search.historyDocuments.find(doc => doc.id === documentId);
  if (searchDocument) {
    dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: getAttachment(searchDocument, attachmentId) });
    return dispatch(loadUrlDocumentAttachment(searchDocument, attachmentId));
  }

  // Unsynchronized document without metadata
  return documentsCollection.get(documentId)
    .then((response) => {
      const document = new DocumentEntity(response.body(false));
      dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: document });
      return dispatch(loadUrlDocumentAttachment(document, attachmentId));
    })
    .catch((err) => {
      dispatch({ type: LOAD_DOCUMENT_METADATA_FAILURE, payload: err });
      console.error('Error while loading document', err);
      Raven.captureException(err);
    });
};

export const resetDocument = () => ({
  type: RESET_DOCUMENT,
  payload: {},
});

/**
 * ====================================
 * The reducer
 * ====================================
 */
const initialState = {
  metadata: {}, // Document/Attachment metadata
  data: null, // Attachment url
  error: false,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_DOCUMENT:
      return initialState;
    case LOAD_DOCUMENT_START:
      return {
        metadata: {},
        data: null,
        error: false,
        loading: true,
      };
    case LOAD_DOCUMENT_METADATA_FAILURE:
    case LOAD_DOCUMENT_ATTACHMENT_FAILURE:
      return {
        metadata: {},
        data: null,
        error: true,
        loading: false,
      };
    case LOAD_DOCUMENT_METADATA_SUCCESS:
      return {
        ...state,
        metadata: action.payload,
        error: false,
      };
    case LOAD_DOCUMENT_ATTACHMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: false,
        loading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/document/documentDucks.js